import type { CampaignType } from '~/admin/campaigns/interfaces';
import type { Channel } from './reducer';

export type HelpMeCampaignItem = {
  campaignId: number;
  channelId: number;
  channelType: string;
};

export const channelTypeToBuilderChannel = (channelType: string): Channel | null => {
  switch (channelType) {
    case 'GooglePost':
      return 'googlePost';
    case 'MessageGroup':
      return 'email';
    case 'SocialPost':
      return 'socialPost';
    case 'TextMessageGroup':
      return 'text';
    default:
      return null;
  }
};

export const builderChannelToContentType = (channel: Channel): CampaignType | null => {
  switch (channel) {
    case 'email':
      return 'message_group';
    case 'socialPost':
      return 'social_post';
    case 'text':
      return 'text_message_group';
    default:
      return null;
  }
};

export const campaignItemsToBuilderContext = (items: HelpMeCampaignItem[]) => {
  const context: {
    campaignId?: number;
    emailChannelId?: number;
    socialChannelId?: number;
    textChannelId?: number;
  } = {};

  if (items[0] !== undefined) {
    context.campaignId = items[0].campaignId;
  }

  items.forEach((item) => {
    switch (item.channelType) {
      case 'MessageGroup':
        context.emailChannelId = item.channelId;
        break;
      case 'SocialPost':
        context.socialChannelId = item.channelId;
        break;
      case 'TextMessageGroup':
        context.textChannelId = item.channelId;
        break;
    }
  });

  return context;
};
